module.exports = __webpack_public_path__ + "static/img/bc-2.7603dcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc-2.png
// module id = kSBQ
// module chunks = 0